export const getInvestmentsTourSteps = () => [
  {
    target: '[data-tour="investments-header"]',
    content: 'Welcome to Investments & Allocations! Here you can track recurring investments and see how they contribute to your asset growth over time.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="investments-summary"]',
    content: 'View key metrics: total annual investment, active investments count, average expected return, and number of asset classes.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="investments-categories"]',
    content: 'Filter investments by asset class to focus on specific categories like Equity, Debt, Gold, or Fixed Deposits.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="investments-table"]',
    content: 'See all your investments in one place. Each investment shows name, asset class, annual amount, frequency, expected return, and auto-reinvest settings.',
    placement: 'top',
  },
  {
    target: '[data-tour="investments-chart"]',
    content: 'The Investment Timeline chart shows your total annual investment contributions over time, helping you visualize your investment journey.',
    placement: 'top',
  },
  {
    target: '[data-tour="investments-distribution"]',
    content: 'The Asset Class Distribution pie chart shows how your current year investments are allocated across different asset classes.',
    placement: 'left',
  },
];



